import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from './auth.service'
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatTabGroup } from '@angular/material/tabs';
import { catchError, finalize, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-app-login',
  templateUrl: './app-login.component.html',
  styleUrls: ['./app-login.component.scss']
})
export class AppLoginComponent implements OnInit, OnDestroy {

  loading = false; 

  registerFormGroup = new FormGroup({
    name: new FormControl(''),
    dob: new FormControl(''),
    email: new FormControl(''),
    password: new FormControl('')
  })
  loginFormGroup = new FormGroup({
    email: new FormControl(''),
    password: new FormControl('') 
  });

  @ViewChild('tabGroup') tabGroup: MatTabGroup
  constructor(private signupSvc: AuthService, private router: Router, private snack: MatSnackBar, private afs: AngularFirestore) { }

  ngOnInit(): void {
  }

  loginWithEmailPass(){
    this.loading = true; 
    if(this.loginFormGroup.valid)
    {
      this.signupSvc.loginWithEmail(this.loginFormGroup.value).pipe(
        
        finalize( () => {
          this.loading = false; 
          this.router.navigate(["/main"])
        }),
        catchError( (err) => {this.snack.open(err.message); return of(err)}),
        take(1)
      ).subscribe()
    }
    else{
      this.snack.open("Please make fill out both fields.", 'close')
    }
  }
  loginWithFacebook(){
    this.loading = true; 
    this.signupSvc.loginWithFB().then(
      () => {
        this.router.navigate(["/main"])
      }
    ).catch( err =>{
      this.showErr(err.message)
    })
  }
  loginWithGoogleBtn(){
    this.loading = true; 
    this.signupSvc.loginWithGoogle().then(
      () => {
        this.loading = false; 
        this.router.navigate(["/main"])
      }
    ).catch( err =>{this.showErr(err.message)})
  }
  createProfile = (user) =>{ this.afs.collection("activeUsers").doc(user.user.uid).set(
    {
      user: user.user,
      dateCreated: new Date()
    }
  )
}

forgotPassword = () => this.loginFormGroup.controls.email.valid? this.signupSvc.sendPasswordResetLink(this.loginFormGroup.controls.email.value).then( () => this.snack.open("To continue reset, check email.", 'close')).catch( (err) => this.showErr(err)) : this.showErr({message: "Please enter an email in the email field."})
showErr = (err) => this.snack.open(err.message, "close")
registerUser = () => this.signupSvc.registerUserEmailAndPassword(this.registerFormGroup.value).then( (res) => {
  if(res === 'registered'){
    this.router.navigate(["/main"])
  }
}).catch(
  err => {
    console.error(err.message)

  }
)

  ngOnDestroy(){}
  

}
